import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageLayout from '../../components/layout/PageLayout';
import Chevron from '../../components/content/Chevron';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import '../../styles/AppParity.css';
import './Browse.css';
export function DetailHeading({ kind, mobile = false }) {
  const navigate = useNavigate(),
    { locale } = useWebLocale(),
    en = locale === 'en';
  const title =
    kind === 'artist'
      ? en
        ? 'Artist'
        : '아티스트'
      : kind === 'playlist'
        ? en
          ? 'Playlist'
          : '플리'
        : en
          ? 'Album'
          : '앨범';
  return (
    <div className={`pp-detail-heading${mobile ? ' pp-browse-mobile-heading' : ''}`}>
      <button
        type="button"
        className="pp-browse-back"
        aria-label={en ? 'Back' : '뒤로'}
        onClick={() => (window.history.state?.idx > 0 ? navigate(-1) : navigate('/explore'))}
      >
        <Chevron direction="left" />
      </button>
      <span>{title}</span>
    </div>
  );
}
export default function DetailShell({ kind, children }) {
  return (
    <PageLayout paddingTop={{ xs: '8px', md: '12px' }}>
      <div className="pp-parity pp-browse pp-detail">
        <DetailHeading kind={kind} />
        {children}
      </div>
    </PageLayout>
  );
}
